import axios from "axios";
import { useRef } from "react";
import { config, entityTypes } from "../utils/Constants";
import TS from "../utils/TimeStampGenerator";
import { useNavigate } from "react-router-dom";
import useErrorHandler from "../components/ErrorHandler";
import useExchangePortalAxios from "../utils/axios";
import jwtDecode from "jwt-decode";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { resetResponseState } from "../features/responseSlice";
import { setWebSocket } from "../features/webSocketSlice";

const useGenerateToken = () => {
  const { ErrorHandler } = useErrorHandler();
  const dispatch = useDispatch();

  const URL = config.url;

  const navigate = useNavigate();

  const ExchangePortalClient = useExchangePortalAxios();

  const generateToken = async (sessionID, timerStatus, data) => {
    return await axios
      .post(
        URL + "/v1/Auth/GeneratePortalToken",
        { SessionID: sessionID },
        {
          headers: {
            "content-type": "application/json",
          },
        }
      )
      .then((res) => {
        dispatch(setWebSocket(res.data.Payload.WebSokcetToken));
        var obj = res.data.Payload;
        for (var key in obj) {
          if (res.data.Payload.hasOwnProperty(key))
            sessionStorage.setItem(key, obj[key]);
        }

        if (sessionStorage.getItem("EntityRole") === entityTypes.legal) {
          const features = sessionStorage.getItem("Features");
          const parsedFeatures = features ? JSON.parse(features) : [];
          //first feature that has the Functions array not empty
          const firstFeature = parsedFeatures.find(
            (feature) => feature.Features.length > 0
          );

          const redirectSlug = firstFeature.Features[0]?.Slug || "Overview";

          //navigate to redirectSlug directly after the base url
          navigate("/" + redirectSlug, { replace: true });
        } else {
          navigate("/overview", { replace: true });
        }
      })
      .catch((err) => {
        clearInterval(timerStatus);
        ErrorHandler(err);
        throw err;
      });
  };

  const generateRefreshToken = async (sessionID, refreshToken) => {
    return await ExchangePortalClient.post("/v1/Auth/RefreshPortalToken", {
      RefreshToken: refreshToken,
      SessionID: sessionID,
      TS: TS(),
    })
      .then((res) => {
        const token = res.data.Payload.Token;
        const tokenivs = btoa(process.env.REACT_APP_IVS_TOKEN);

        sessionStorage.setItem("Token", token);
        sessionStorage.setItem("IVSToken", tokenivs);

        sessionStorage.setItem("EntityRole", res.data.Payload.Role);
        sessionStorage.setItem("EntityType", res.data.Payload.EntityType);
        sessionStorage.setItem("EntityID", res.data.Payload.EntityID);

        return res;
      })
      .catch((error) => {
        sessionStorage.clear();
        dispatch(resetResponseState());

        toast.error(`Your session has expired. Please login again.`);
        navigate("/", { replace: true });

        throw error;
      });
  };

  return {
    generateToken,
    generateRefreshToken,
  };
};

export default useGenerateToken;
